import { render, staticRenderFns } from "./TabAllLocationsSlideCopy.vue?vue&type=template&id=5dd25ed8&scoped=true"
import script from "./TabAllLocationsSlideCopy.vue?vue&type=script&lang=js"
export * from "./TabAllLocationsSlideCopy.vue?vue&type=script&lang=js"
import style0 from "./TabAllLocationsSlideCopy.vue?vue&type=style&index=0&id=5dd25ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd25ed8",
  null
  
)

export default component.exports